module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/cinemitch-avatar-7c3444f13d175b6fb67749c58c5451cb.jpg";